import React from 'react';
import { FieldError } from 'react-hook-form';

import { S } from './TextArea.styles';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: FieldError | undefined;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(
  (props, ref) => {
    const { label, ...rest } = props;
    return (
      <div>
        <S.Wrapper>
          <S.Label>{label}</S.Label>
          <S.Textarea {...rest} ref={ref} />
        </S.Wrapper>
        {props.error && (
          <S.Error>
            <S.B3 $color="error">{props.error.message}</S.B3>
          </S.Error>
        )}
      </div>
    );
  }
);
